import { AlertTriangle } from 'lucide-react'

type PermissionsHeaderProps = {
  isPrivate: boolean
  existingRolesUnknown?: boolean
}

export const PermissionsHeader = ({ isPrivate, existingRolesUnknown }: PermissionsHeaderProps) => {
  return (
    <>
      <div>
        <p className="text-sm text-muted-foreground">
          Choose who can view and download this document.
        </p>
      </div>

      {existingRolesUnknown && !isPrivate && (
        <div className="flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
          <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
          <p>
            Couldn&apos;t load this document&apos;s current role assignments — only check roles
            below if you want to <strong>replace</strong> who has access. Leave this section alone
            to keep existing permissions unchanged.
          </p>
        </div>
      )}
    </>
  )
}
